const BFV_ASSOCIATION_ID = "00ES8GNCQK000000VV0AG08LVUPGND5I";

export function buildBfvClubLogoUrl(clubId?: string | null) {
  if (!clubId) return "";

  return `https://app.bfv.de/export.media/-/action/getLogo/format/2/id/${clubId}/verband/${BFV_ASSOCIATION_ID}/strat_code/bfv`;
}

export function getClubLogoUrl(club?: { clubPermanentId?: string | null; logoUrl?: string | null } | null) {
  return club?.logoUrl || buildBfvClubLogoUrl(club?.clubPermanentId) || "";
}